import { extractImageFrames, clampTo } from '../../tools';
import type { KieModelConfig } from '../types';

export const volcengineConfigs: Record<string, KieModelConfig> = {
    'seedance-2.0-mini-no-review': {
        // https://kie.ai/seedance-2-0-mini
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, videoUri, videoUris, audioUri, audioUris, duration, aspectRatio, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'bytedance/seedance-2-mini',
                    input: {
                        prompt: prompt.slice(0, 20000),
                        aspect_ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['16:9', '4:3', '1:1', '3:4', '9:16', '21:9'] as const, '16:9'),
                        duration: clampTo(duration || 15, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 15),
                        resolution: clampTo(quality || '720p', ['480p', '720p'] as const, '720p'),
                        // 首帧 URL
                        first_frame_url: firstImage!,
                        // 可选参数
                        generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                        web_search: typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search : false,
                        // system
                        nsfw_checker: false,
                    },
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    model: 'bytedance/seedance-2-mini',
                    input: {
                        prompt: prompt.slice(0, 20000),
                        aspect_ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['16:9', '4:3', '1:1', '3:4', '9:16', '21:9'] as const, '16:9'),
                        duration: clampTo(duration || 15, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 15),
                        resolution: clampTo(quality || '720p', ['480p', '720p'] as const, '720p'),
                        // 首帧 URL
                        first_frame_url: firstImage!,
                        // 尾帧 URL
                        last_frame_url: lastImage!,
                        // 可选参数
                        generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                        web_search: typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search : false,
                        // system
                        nsfw_checker: false,
                    },
                };
            // 参考模式
            } else if (frameMode === 'ref') {
                const images = (imagePrompt ?? []).filter(Boolean).slice(0, 9);
                const allMedia = [
                    ...((videoUris?.length ?? 0) > 0 ? videoUris! : videoUri ? [videoUri] : []).filter(Boolean).map(url => ({ type: 'video' as const, url })),
                    ...((audioUris?.length ?? 0) > 0 ? audioUris! : audioUri ? [audioUri] : []).filter(Boolean).map(url => ({ type: 'audio' as const, url })),
                ].slice(0, 3);
                const videos = allMedia.filter(m => m.type === 'video').map(m => m.url);
                const audios = allMedia.filter(m => m.type === 'audio').map(m => m.url);
                return {
                    model: 'bytedance/seedance-2-mini',
                    input: {
                        prompt: prompt.slice(0, 20000),
                        aspect_ratio: aspectRatio === 'match' ? 'adaptive' : clampTo(aspectRatio || '16:9', ['16:9', '4:3', '1:1', '3:4', '9:16', '21:9'] as const, '16:9'),
                        duration: clampTo(duration || 15, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 15),
                        resolution: clampTo(quality || '720p', ['480p', '720p'] as const, '720p'),
                        // 参考 URL
                        reference_image_urls: images,
                        reference_video_urls: videos,
                        reference_audio_urls: audios,
                        // 可选参数
                        generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                        web_search: typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search : false,
                        // system
                        nsfw_checker: false,
                    },
                };
            // 文生视频模式
            } else {
                return {
                    model: 'bytedance/seedance-2-mini',
                    input: {
                        prompt: prompt.slice(0, 20000),
                        aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '4:3', '1:1', '3:4', '9:16', '21:9'] as const, '16:9'),
                        duration: clampTo(duration || 15, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 15),
                        resolution: clampTo(quality || '720p', ['480p', '720p'] as const, '720p'),
                        // 可选参数
                        generate_audio: typeof providerOptions?.audio === 'boolean' ? providerOptions.audio : true,
                        web_search: typeof providerOptions?.web_search === 'boolean' ? providerOptions.web_search : false,
                        // system
                        nsfw_checker: false,
                    },
                };
            }
        },
    },
};